import React from 'react';
import styled from 'styled-components';
import { MemoryRouter, Route, Switch, useHistory } from 'react-router-dom';
import { ContactDrawerContext, LayoutContext } from 'contexts';
import { Drawer, theme } from 'components';
import {
  CoopDrawerContent,
  DrawerContent,
  TeamDrawerContent,
} from './components';
import { DRAWER_WIDTH } from './constants';

import { ContactDrawerMode, ContactDrawerType } from './types';

const ContactDrawer: React.FC = () => {
  const {
    contactDrawerType,
    contactDrawerMode,
    contactDrawerVisible,
    closeContactDrawer,
    contactId,
  } = React.useContext(ContactDrawerContext);

  const { isMobileView, offsetTop } = React.useContext(LayoutContext);

  const history = useHistory();

  const initialRoute = contactId
    ? `/${contactDrawerType}/${contactId}`
    : `/${contactDrawerType}/${contactDrawerMode}`;

  return (
    <StyledDrawer
      open={contactDrawerVisible}
      onClose={() => closeContactDrawer()}
      drawerStyle={{
        background: theme.white,
        padding: isMobileView ? 0 : `0 0 ${offsetTop}px 0`,
      }}
      bodyStyle={{ padding: 0 }}
      closable={false}
      width={DRAWER_WIDTH}
      type={isMobileView ? 'mobile' : undefined}
      destroyOnClose
    >
      <MemoryRouter initialEntries={[initialRoute]} initialIndex={0}>
        <Switch>
          <Route
            path="/user/:id"
            exact
            render={props => (
              <DrawerContent
                key={props.match.params.id}
                mode={ContactDrawerMode.Profile}
                type={ContactDrawerType.User}
                parentHistory={history}
                {...props}
              />
            )}
          />
          <Route
            path="/team/:id"
            render={props => (
              <TeamDrawerContent
                key={props.match.params.id}
                mode={ContactDrawerMode.Profile}
                type={ContactDrawerType.Team}
                parentHistory={history}
                {...props}
              />
            )}
          />
          <Route
            path="/contact/add"
            exact
            render={props => (
              <DrawerContent
                mode={ContactDrawerMode.Add}
                type={ContactDrawerType.Contact}
                parentHistory={history}
                {...props}
              />
            )}
          />
          <Route
            path="/contact/:id"
            exact
            render={props => (
              <DrawerContent
                key={props.match.params.id}
                mode={ContactDrawerMode.Profile}
                type={ContactDrawerType.Contact}
                parentHistory={history}
                {...props}
              />
            )}
          />
          <Route
            path="/contact/:id/edit"
            render={props => (
              <DrawerContent
                key={props.match.params.id}
                mode={ContactDrawerMode.Edit}
                type={ContactDrawerType.Contact}
                parentHistory={history}
                {...props}
              />
            )}
          />
          <Route
            exact
            path={`/${ContactDrawerType.Coop}/${ContactDrawerMode.Profile}`}
            render={props => (
              <CoopDrawerContent parentHistory={history} {...props} />
            )}
          />
        </Switch>
      </MemoryRouter>
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  z-index: 1000;
  .drawer-content-container {
    /* total width */
    &::-webkit-scrollbar {
      background-color: transparent;
      width: 16px;
    }

    /* background of the scrollbar except button or resizer */
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    /* scrollbar itself */
    &::-webkit-scrollbar-thumb {
      background-color: #babac0;
      border-radius: 16px;
      border: 4px solid #fff;
      max-height: 112px;
    }

    /* set button(top and bottom of the scrollbar) */
    &::-webkit-scrollbar-button {
      display: none;
    }
    overflow-y: scroll;
    padding: 0px 8px 24px 24px;
  }
  .full-width-wrapper {
    width: 100%;
  }
`;

export default ContactDrawer;
